<template>
    <v-switch
        @change="switchPackageArchiving"
        :loading="loading" :readonly="loading"
        v-model="active"
    ></v-switch>
</template>

<script>
export default {
    name: "PackageActivationSwitch",
    props: {
        pkg: Object
    },
    data() {
        return {
            active: null,
            loading: false,
        }
    },
    methods: {
        switchPackageArchiving: function () {
            this.loading = true;

            apiAxios.put('packages/'+this.pkg.PackageID+'/archiving', {
                Archived: !this.active
            })
                .then((response) => {
                    if(response.status === 200) {
                        this.$store.commit(
                            "showSnackbarSuccess",
                            'Zmieniono status kompletu.'
                        );
                    } else {
                        this.active = !this.active;
                        this.$store.commit(
                            "showSnackbarError",
                            'Nie udało się zmienić statusu kompletu.'
                        );
                    }
                })
                .catch(() => {
                    this.active = !this.active;
                })
                .then(() => {
                    this.loading = false;
                });
        },
    },
    created() {
        this.active = !this.pkg.Archived;
    }
}
</script>

<style scoped>

</style>
